// extracted by mini-css-extract-plugin
export default {"identifierContainer":"customerForm_identifierContainer__2YG34","editableField":"customerForm_editableField__N-Ev1","creditDays":"customerForm_creditDays__aY0Ii"};